import { render, staticRenderFns } from "./ProfessionalForm.vue?vue&type=template&id=172a9a93"
import script from "./ProfessionalForm.vue?vue&type=script&lang=js"
export * from "./ProfessionalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports